module.exports = __webpack_public_path__ + "img/eh.66b6b954.svg";